// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".backTop[data-v-c66723de] .ant-back-top {\n  background-color: #1890ff;\n  text-align: center;\n  line-height: 40px;\n  border-radius: 50%;\n  bottom: 50px !important;\n}", ""]);
// Exports
module.exports = exports;
